var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 25.3125C2.44687 25.3125 1.6875 24.5565 1.6875 23.625L1.6875 3.375C1.6875 2.4435 2.44687 1.6875 3.375 1.6875L23.625 1.6875C24.5565 1.6875 25.3125 2.4435 25.3125 3.375L25.3125 23.625C25.3125 24.5565 24.5565 25.3125 23.625 25.3125L3.375 25.3125ZM27 23.625L27 3.375C27 1.51116 25.4888 0 23.625 0L3.375 0C1.51031 0 0 1.51116 0 3.375L0 23.625C0 25.4888 1.51031 27 3.375 27L23.625 27C25.4888 27 27 25.4888 27 23.625ZM19.8576 14.2417C20.0601 14.0392 20.1234 13.7624 20.077 13.5C20.1234 13.2376 20.0601 12.9608 19.8576 12.7583L15.0854 7.98612C14.7555 7.65621 14.2206 7.65621 13.8924 7.98612C13.5625 8.31434 13.5625 8.84927 13.8924 9.17918L17.3694 12.6563L8.4375 12.6563C7.97344 12.6563 7.59375 13.0334 7.59375 13.5C7.59375 13.9657 7.97344 14.3438 8.4375 14.3438L17.3694 14.3438L13.8924 17.8208C13.5625 18.1507 13.5625 18.6848 13.8924 19.0139C14.2206 19.3438 14.7555 19.3438 15.0854 19.0139L19.8576 14.2417Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowRight);
export default __webpack_public_path__ + "static/media/BlackArrowRight.376f12071935a0297ee292523b329e4e.svg";
export { ForwardRef as ReactComponent };